import { Api } from 'utils';

class GuideService {
  static admin = {
    get: async (params?: any) => Api.createResponse('admin/guides/', params),
    create: async (params?: any) =>
      Api.createResponse('admin/guides/create', params),
    update: async (params?: any) =>
      Api.createResponse('admin/guides/update', params),
    delete: async (params?: any) =>
      Api.createResponse('admin/guides/delete', params),
    getAreas: async (params?: any) =>
      Api.createResponse('admin/guides/areas', params),
  };
}

export default GuideService;
